import Velocity from 'velocity-animate';

export const velocity = ( elm, args ) => {
  return new Promise( ( resolve ) => {
    const opts = {
      complete: () => {
        ( typeof args.cb !== 'undefined' ) ? args.cb() : void 0;
        resolve();
      }
    };
    Velocity( elm, args.props, Object.assign( opts, args.opts ) );
  });
};
